import script from "./KitProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./KitProgress.vue?vue&type=script&setup=true&lang=js"

import "./KitProgress.vue?vue&type=style&index=0&id=280d4fb8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-280d4fb8"]])

export default __exports__